import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _BulkPayoutsFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.00049C13.5809 1.00049 15.0828 1.33653 16.4414 1.93701C16.4112 2.06965 16.3936 2.20734 16.3936 2.34912C16.3936 3.06239 16.7975 3.68073 17.3887 3.98975L16.3506 5.02881C15.6279 5.75152 15.6281 6.92318 16.3506 7.646C17.0734 8.3688 18.245 8.36879 18.9678 7.646L20.0068 6.60693C20.3156 7.19879 20.9337 7.60389 21.6475 7.604C21.79 7.604 21.9282 7.58569 22.0615 7.55518C22.6631 8.91483 23 10.418 23 12.0005C23 18.0756 18.0751 23.0005 12 23.0005C5.92487 23.0005 1 18.0756 1 12.0005C1 5.92536 5.92487 1.00049 12 1.00049ZM16 12.7485C15.7748 13.0179 15.5207 13.2511 15.2568 13.4438C14.3853 14.0835 13.2383 14.4438 12.0176 14.4438C10.7967 14.4438 9.64991 14.0829 8.77832 13.4438C8.51065 13.2495 8.26098 13.0165 8.03516 12.7485V14.0786C8.03516 15.6928 9.81809 17.0005 12.0176 17.0005C14.217 17.0005 16 15.6928 16 14.0786V12.7485ZM12.0176 8.00049C9.81866 8.00049 8.03553 9.19056 8.03516 10.6587C8.03516 12.127 9.81843 13.3179 12.0176 13.3179C14.2166 13.3178 16 12.127 16 10.6587C15.9996 9.1906 14.2164 8.00056 12.0176 8.00049Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2444 3.20022C17.7745 3.20022 17.3935 2.81928 17.3935 2.34938C17.3935 1.87947 17.7745 1.49854 18.2444 1.49854H21.6478C22.1177 1.49854 22.4986 1.87947 22.4986 2.34938V5.75274C22.4986 6.22265 22.1177 6.60358 21.6478 6.60358C21.1778 6.60358 20.7969 6.22265 20.7969 5.75274V4.40349L18.2611 6.93933C17.9288 7.2716 17.3901 7.2716 17.0578 6.93933C16.7255 6.60706 16.7255 6.06833 17.0578 5.73606L19.5936 3.20022H18.2444Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const BulkPayoutsFilledIcon = assignWithoutSideEffects(_BulkPayoutsFilledIcon, {
  componentId: 'BulkPayoutsFilledIcon',
});

export default BulkPayoutsFilledIcon;
